import { LocaleEnum } from '@systemeio/ui-frontend'
import { DateFormatEnum } from 'shared/enums/date-time-format-enum'
import { UserInterface } from 'shared/types/user-interface'
import { CourseLectureAssignmentStatusEnum } from 'modules/course/types/course-menu-interface'

export const convertAssignmentDate = (
  dateStr?: string,
  format?: {
    dateFormat?: DateFormatEnum
    timeZone?: UserInterface['timezone']
    locale?: LocaleEnum
  },
) => {
  if (!dateStr) return ''

  const date = new Date(dateStr)

  return date.toLocaleString(format?.locale ?? LocaleEnum.ENGLISH, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: format?.timeZone,
  })
}

export const getAssignmentStatusTextColor = (status?: CourseLectureAssignmentStatusEnum) => {
  switch (status) {
    case CourseLectureAssignmentStatusEnum.Approved:
      return 'text-green'
    case CourseLectureAssignmentStatusEnum.Rejected:
      return 'text-[#ED1C24]'
    case CourseLectureAssignmentStatusEnum.Pending:
      return 'text-brand-primary'
    case CourseLectureAssignmentStatusEnum.NotSubmitted:
      return 'text-[#19191B]'
    default:
      break
  }
}

export const getAssignmentStatusBackgroundColor = (status?: CourseLectureAssignmentStatusEnum) => {
  switch (status) {
    case CourseLectureAssignmentStatusEnum.Approved:
      return 'bg-[#D8F9E1]'
    case CourseLectureAssignmentStatusEnum.Rejected:
      return 'bg-[#FFE5E3]'
    case CourseLectureAssignmentStatusEnum.Pending:
      return 'bg-[#DFF1FD]'
    case CourseLectureAssignmentStatusEnum.NotSubmitted:
      return 'bg-[#F2F2F3]'
    default:
      break
  }
}
